module.exports = __webpack_public_path__ + "img/roundtable-3.7653bcbd.png";